import { motion } from 'framer-motion'
import type { SlideProps } from '@/components/SlideWizard'
import heroImg from '@/assets/emotional-hijack.jpg'
import { useSlideCopy } from '@/lib/i18n'
import { copy } from './Slide0Title.copy'

const ease = [0.16, 1, 0.3, 1] as const

export default function Slide0Title(_props: SlideProps) {
  const c = useSlideCopy(copy)
  return (
    <div className="min-h-[60vh] flex flex-col items-center justify-center text-center px-4 mx-auto max-w-3xl">
      <motion.img
        src={heroImg}
        alt=""
        initial={{ opacity: 0, scale: 0.9 }}
        animate={{ opacity: 0.8, scale: 1 }}
        transition={{ duration: 0.6, delay: 0.1, ease }}
        className="mb-6 h-28 sm:h-36 w-auto select-none"
      />

      <motion.p
        initial={{ opacity: 0, y: 10 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.5, delay: 0.2, ease }}
        className="mb-4 text-sm sm:text-base uppercase tracking-[0.25em] text-slate-400 font-semibold"
      >
        {c.eyebrow}
      </motion.p>

      <motion.h1
        initial={{ opacity: 0, y: 14 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.6, delay: 0.2, ease }}
        className="text-5xl sm:text-7xl font-semibold text-slate-900 tracking-tight leading-[1.05]"
      >
        {c.title}
      </motion.h1>

      <motion.p
        initial={{ opacity: 0, y: 14 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.6, delay: 0.4, ease }}
        className="mt-6 text-xl sm:text-2xl text-slate-500 leading-relaxed max-w-lg"
      >
        {c.subtitle}
      </motion.p>

      <motion.p
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ duration: 0.8, delay: 1.0, ease }}
        className="mt-10 flex items-center gap-2 text-xs sm:text-sm text-slate-400 normal-case tracking-normal font-medium select-none"
      >
        <span className="hidden sm:inline">{c.hintDesktop}</span>
        <span className="sm:hidden">{c.hintMobile}</span>
      </motion.p>
    </div>
  )
}
